export const getFilteredOperationsVariables = (startDate, endDate, marketType, searchTextField) => ({
  input: {
    filters: {
      marketType: marketType || 'EXPORT',
      destinationId: null,
      endDate: startDate && endDate ? {
        maxDate: endDate,
        minDate: startDate,      
      } : null,
      incoterms: [],
      statuses: ['CONFIRMED'],
      isWM: false,
      isWarehouse: false,
    },
    searchText: searchTextField || '',
  },
});
